// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".media-settings-row {\n  padding: 0.75rem 0 0.25rem 0;\n}\n@media (min-width: 900px) {\n  .media-settings-row {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    grid-gap: 1rem;\n  }\n}\n.semantic-ui .ui.form .media-settings-row .field:last-child {\n  margin-bottom: 1rem;\n}\n", ""]);
// Exports
module.exports = exports;
